// extracted by mini-css-extract-plugin
module.exports = {"customShadow":"RSToast_customShadow__B9Mqr","customEnter":"RSToast_customEnter__DCgmR","customExit":"RSToast_customExit__5_9RT"};